"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LeadGenSuccess;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _button = _interopRequireDefault(require("@ux/button"));
var _core = require("@linaria/core");
var _index = require("./index");
var _image = require("@site/pattern-library-core/image");
var _videoSection = _interopRequireDefault(require("../../../page-body/media-components/video-section"));
var _baseActions = _interopRequireDefault(require("../actions/base-actions"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _inputBar = _interopRequireDefault(require("@site/pattern-library-core/input-bar"));
var _domainSearch = _interopRequireDefault(require("@site/pattern-library-core/domain-search"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-statements */

const Logo = /*#__PURE__*/(0, _react2.styled)(_image.LazyImage)({
  name: "Logo",
  class: "pl-l1udhxqb"
});
const SuccessWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SuccessWrapper",
  class: "pl-sbb112g"
});
const SuccessImage = /*#__PURE__*/(0, _react2.styled)("img")({
  name: "SuccessImage",
  class: "pl-s1jtmj13"
});
const StyledDescription = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "StyledDescription",
  class: "pl-spgmm4u"
});
const HeaderImage = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeaderImage",
  class: "pl-h1xz4rmp"
});
const LinkWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "LinkWrapper",
  class: "pl-l1ob3kbe"
});
const Link = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "Link",
  class: "pl-l1ksr9xi"
});
const VideoWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "VideoWrapper",
  class: "pl-v3viwww"
});
const Video = /*#__PURE__*/(0, _react2.styled)(_videoSection.default)({
  name: "Video",
  class: "pl-vkygt4u"
});
const Ctas = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Ctas",
  class: "pl-c1xii8wu"
});
const CloseButton = "pl-cas6i6d";
const getOptOutCookie = () => {
  if (typeof document !== 'undefined') {
    const match = document.cookie.match(new RegExp('(^| )OPTOUTMULTI=([^;]+)'));
    return match ? match[2] : '';
  }
  return '';
};

/**
 * LeadGenSuccess Component
 *
 * @param {Object} props React props
 * @param {Function} props.onClose Function to close the modal
 * @param {Object} props.leadType Deprecated with pipedrive, do not use
 * @param {Object} props.productIntent Routes the lead to the correct Salesforce instance
 * @param {String} props.payMeNumber The contact number rendered immediately after the subheading
 * @param {Object} props.modalHeader  The asset rendered above the title text on the form modal
 * @param {Array} props.helpfulLinks Optional links to direct user to related resources
 * @param {Object} props.successImage Image render near the top of the main success modal
 * @param {Object} props.successVideo  A video that renders dead-center of the success modal
 * @param {String} props.successHeader The title text rendered on the success modal
 * @param {String} props.successCloseText The text rendered near the bottom to close the modal
 * @param {Stromg} props.successSubHeading The descriptive text rendered below the header on the success modal
 * @param {String} props.expectedSignedaGPV The expected signed aGPV value for the lead
 * @returns {React.ReactElement} LeadGenSuccess Component
 * @public
 */
function LeadGenSuccess({
  onClose,
  leadType,
  productIntent,
  payMeNumber,
  modalHeader,
  helpfulLinks,
  successImage,
  successVideo,
  successHeader,
  successCloseText,
  successSubHeading,
  expectedSignedaGPV = '0.0',
  ctas,
  ...rest
}) {
  const optOutMultiCookie = getOptOutCookie();
  const gaveConsent = optOutMultiCookie && optOutMultiCookie.includes('c2:0');
  (0, _react.useEffect)(() => {
    // TODO: cleanup post swp-siteglass https://jira.godaddy.com/browse/NXT-1930
    (0, _patternLibraryUtils.logImpression)('fos.cms.commerce.page-body.request_a_demo_form.success');
    const isPayments = leadType?.leadType === 'Payments' || productIntent?.Value.toLowerCase().includes('commerce');
    if (isPayments && gaveConsent && global._analyticsDataLayer) {
      (0, _index.pushToGoogleAnalytics)('event', 'conversion', {
        send_to: 'AW-1069554140/dv6wCLqohIgDENyzgP4D',
        value: expectedSignedaGPV,
        currency: 'USD'
      });
      (0, _index.pushToGoogleAnalytics)('event', 'conversion', {
        allow_custom_scripts: true,
        send_to: 'DC-8316070/conve0/godad00g+standard'
      });
    }
  }, [expectedSignedaGPV, gaveConsent, leadType?.leadType, productIntent?.Value]);
  return /*#__PURE__*/_react.default.createElement(SuccessWrapper, (0, _extends2.default)({
    "data-cy": "lead-gen-success"
  }, _patternLibraryUtils.tracking.create('success', false, true), rest), modalHeader?.url && /*#__PURE__*/_react.default.createElement(HeaderImage, null, /*#__PURE__*/_react.default.createElement(Logo, {
    dataCy: "logo",
    url: modalHeader.url,
    altText: modalHeader.altText
  })), successVideo && /*#__PURE__*/_react.default.createElement(VideoWrapper, null, /*#__PURE__*/_react.default.createElement(Video, (0, _extends2.default)({}, successVideo, {
    fitsWrapper: true,
    portalElem: document.body
  }))), successImage?.url && /*#__PURE__*/_react.default.createElement(SuccessImage, {
    src: successImage.url,
    alt: successImage.altText,
    height: successImage.height,
    width: successImage.width,
    "data-cy": "success-image"
  }), /*#__PURE__*/_react.default.createElement("h2", {
    "data-cy": "header"
  }, successHeader), /*#__PURE__*/_react.default.createElement(StyledDescription, null, /*#__PURE__*/_react.default.createElement("span", {
    "data-cy": "sub-heading"
  }, successSubHeading), /*#__PURE__*/_react.default.createElement("span", {
    "data-cy": "pay-me-number"
  }, payMeNumber)), helpfulLinks?.length && /*#__PURE__*/_react.default.createElement(LinkWrapper, null, helpfulLinks?.map(({
    id,
    text,
    href
  }) => /*#__PURE__*/_react.default.createElement(Link, {
    key: id,
    href: href
  }, text))), ctas && /*#__PURE__*/_react.default.createElement(Ctas, null, Array.isArray(ctas) ? /*#__PURE__*/_react.default.createElement(_baseActions.default, {
    actionsLayout: "button-set",
    ctas: ctas
  }) : ctas), /*#__PURE__*/_react.default.createElement(_button.default, {
    "data-cy": "lead-gen-form-close-button",
    className: CloseButton,
    text: successCloseText,
    onClick: onClose,
    design: "inline"
  }), gaveConsent && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
    height: "1",
    width: "1",
    alt: "Facebook Pixel",
    style: {
      display: 'none'
    },
    src: "https://www.facebook.com/tr?id=284067518410183&ev=RAC",
    "data-cy": "facebook-pixel"
  }), /*#__PURE__*/_react.default.createElement("img", {
    height: "1",
    width: "1",
    alt: "LinkedIn Pixel",
    style: {
      display: 'none'
    },
    src: "https://px.ads.linkedin.com/collect/?pid=169260&conversionId=6067620&fmt=gif",
    "data-cy": "linkedin-pixel"
  })));
}
LeadGenSuccess.propTypes = {
  onClose: _propTypes.default.func,
  leadType: _propTypes.default.shape({
    leadType: _propTypes.default.string,
    pipeline: _propTypes.default.string,
    pipelineId: _propTypes.default.string,
    defaultTitle: _propTypes.default.string,
    pipedriveInstance: _propTypes.default.string,
    createOrg: _propTypes.default.bool
  }),
  productIntent: _propTypes.default.object,
  payMeNumber: _propTypes.default.string,
  modalHeader: _propTypes.default.shape(_image.imgPropShape),
  successImage: _propTypes.default.shape(_image.imgPropShape),
  helpfulLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string,
    ariaLabel: _propTypes.default.string,
    href: _propTypes.default.string,
    width: _propTypes.default.string,
    size: _propTypes.default.string,
    design: _propTypes.default.string,
    id: _propTypes.default.string
  })),
  successHeader: _propTypes.default.string,
  successCloseText: _propTypes.default.string,
  successSubHeading: _propTypes.default.string,
  expectedSignedaGPV: _propTypes.default.string,
  ctas: _propTypes.default.oneOfType([_propTypes.default.instanceOf(_baseActions.default), _propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.shape(_merchButton.NSMerchButton.propTypes), _propTypes.default.shape(_inputBar.default.propTypes), _propTypes.default.shape(_domainSearch.default.propTypes)]))]),
  successVideo: _propTypes.default.shape(_videoSection.default.propTypes)
};